import React from 'react';
import { Megaphone, ChevronRight } from 'lucide-react';
import { useSite } from '../../context/SiteContext';
import useReveal from '../../hooks/useReveal';
import { isVideoSrc, resolveMediaUrl } from '../admin/MediaUpload';

export default function Promotions() {
  const { data } = useSite();
  const { ref, visible } = useReveal();
  const promo = data.promo || {};
  const media = promo.media || '';
  const mediaIsVideo = isVideoSrc(media);
  const hasMedia = !!media;
  const mediaUrl = resolveMediaUrl(media);
  const logoUrl = resolveMediaUrl(promo.logo);

  const onClick = () => {
    if (!promo.link) return;
    if (/^https?:/.test(promo.link)) window.open(promo.link, '_blank');
    else window.location.hash = promo.link;
  };

  return (
    <button
      ref={ref}
      onClick={onClick}
      className={`w-full relative rounded-xl overflow-hidden text-left click-ripple group transition-all duration-700
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`}
      style={{ background: hasMedia ? '#0a0a0a' : promo.gradient }}
      data-testid="promotions-banner"
    >
      {hasMedia && (
        mediaIsVideo ? (
          <video key={mediaUrl} src={mediaUrl} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <img key={mediaUrl} src={mediaUrl} alt="" className="absolute inset-0 w-full h-full object-cover" />
        )
      )}
      {hasMedia && <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/20" />}
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(ellipse_at_right,rgba(255,255,255,0.5),transparent_50%)] pointer-events-none" />
      <div className="relative px-5 py-3.5 md:py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <span className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center text-white shrink-0 overflow-hidden">
            {promo.logo ? <img src={logoUrl} alt="" className="w-full h-full object-cover" /> : <Megaphone size={18} />}
          </span>
          <span className="text-white font-bold text-base md:text-lg drop-shadow truncate">{promo.title}</span>
        </div>
        <span className="text-white/90 group-hover:translate-x-1 transition-transform shrink-0">
          <ChevronRight size={22} />
        </span>
      </div>
    </button>
  );
}
